// noinspection GraphQLUnresolvedReference

import {gql} from "graphql-request";

export const GetNationalResult = gql`
    mutation ExecuteGetNationalModelPlot (
        $inInfraFlag: String,
        $inSource: String,
        $inResourceGroupID: String,
        $inSuperSectorID: Int,
        $inProjectTypeID: String,
        $inPLEMGroupID: Int,
        $inMasterTypeID: Int,
        $inLevel1GroupID: Int,
        $inLevel2GroupID: Int,
        $inFundingMode: String
        $inUserSID: UUID!
    ) {
        executeGetNationalModelPlot(
            inInfraFlag: $inInfraFlag
            inSource: $inSource
            inResourceGroupID: $inResourceGroupID
            inSuperSectorID: $inSuperSectorID
            inProjectTypeID: $inProjectTypeID
            inPLEMGroupID: $inPLEMGroupID
            inMasterTypeID: $inMasterTypeID
            inLevel1GroupID: $inLevel1GroupID
            inLevel2GroupID: $inLevel2GroupID
            inFundingMode: $inFundingMode
            inUserSID: $inUserSID
        ) {
            Month
            PlantValue
            PlantUnit
            LabourValue
            LabourUnit
            EquipmentValue
            EquipmentUnit
            MaterialValue
            MaterialUnit
            Sum_Unit
            Sum_Value
        }
    }
`;
